export default "__VITE_ASSET__CshidKlY__"